import { BaseThreeScene } from '@modules/three/common/BaseThreeScene';
import FixRotationService from '@modules/fixRotation/fixRotationService.ts';
import fixRotationStore from '@modules/fixRotation/store/fixRotationStore';

export class FixRotationScene extends BaseThreeScene {
  private fixRotationService: FixRotationService | null = null;

  constructor(container: HTMLElement) {
    super(container);
    this.root.camera.position.set(0, 0, 150);
  }

  public async init(upperJawFile: File, lowerJawFile: File) {
    const [upperJaw, lowerJaw] = await BaseThreeScene.loadMeshes([upperJawFile, lowerJawFile]);
    this.fixRotationService = new FixRotationService(upperJaw, lowerJaw);
    fixRotationStore.getState().setFixRotationService(this.fixRotationService);
    this.startRendering();
  }

  public getService(): FixRotationService | null {
    return this.fixRotationService;
  }
}
